import { render, staticRenderFns } from "./orderListItemsdesktop.vue?vue&type=template&id=f3f85d68&"
import script from "./orderListItemsdesktop.vue?vue&type=script&lang=js&"
export * from "./orderListItemsdesktop.vue?vue&type=script&lang=js&"
import style0 from "./orderListItemsdesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports